import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { CommonApiService } from 'src/app/services/common-api.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bot-utility-edit',
  templateUrl: './bot-utility-edit.component.html',
  styleUrls: ['./bot-utility-edit.component.scss']
})
export class BotUtilityEditComponent implements OnInit {
  loader: boolean = false;
  utilityName: any;
  consumerId: any;
  utilityByPincode: any;
  utility: any;
  meter_id: any;
  constructor(public api: CommonApiService, public route: ActivatedRoute, public router: Router) { }

  ngOnInit(): void {
    this.meter_id = this.route.snapshot.params["meter_id"];
    this.getBotUtility();
    this.getBotInfo();
  }


  getBotUtility() {
    this.api.getUtility(400).pipe(first()).subscribe(res => {
      this.utilityByPincode = res;
      // this.utility = res;
    })
  }

  getBotInfo() {
    this.loader = true;
    this.api.botInfoGet(this.meter_id).pipe(first()).subscribe(res => {
      this.loader = false;
      this.utility = res['utility'];
    })
  }

  onUtilityChange(ev) {
    console.log(ev);
    
  }

  saveDetails() {
    this.loader = true
    let formdata = {
      'utility': {
        'consumerId': this.utility.consumerId,
        'utilityName': this.utility.utilityName
      }
    }

    this.api.botDetailsUpdate(this.meter_id, formdata).pipe(first()).subscribe(res => {
      this.loader = false;
      this.router.navigateByUrl(`/bot-utility-details/${this.meter_id}`);
      console.log(res);

    })
  }
}
